export function isInternalWhatsAppContactKey(value) {
  const text = String(value || '');
  return text.startsWith('wa_lid_') || text.startsWith('wa_jid_');
}

export function contactPrimaryLabel(contact) {
  if (contact?.name) return contact.name;
  if (contact?.whatsappPhone) return contact.whatsappPhone;
  if (isInternalWhatsAppContactKey(contact?.phone)) return 'Linked WhatsApp contact';
  return contact?.phone || 'Contact';
}

export function contactPhoneLabel(contact) {
  if (contact?.whatsappPhone) return contact.whatsappPhone;
  if (isInternalWhatsAppContactKey(contact?.phone)) return 'Phone number resolving from WhatsApp';
  return contact?.phone || '';
}

export function contactCallablePhone(contact) {
  if (contact?.whatsappPhone) return contact.whatsappPhone;
  const phone = String(contact?.phone || '');
  return phone.startsWith('+') && !isInternalWhatsAppContactKey(phone) ? phone : '';
}
